import * as React from "react"
import {Box} from "@mui/material";
import {formatNumber} from "@ui-seeker/utils";

import {ArrowBackground} from "@components";


export default function imageMatchColumn() {
    return [{
        name: 'imageMatch', label: 'Image Gallery',
        options: {
            filter: false,
            display: false,
            setCellHeaderProps: () => ({ sx: {
                    whiteSpace: 'pre-wrap',
                    minWidth: 160
                }}),
            customBodyRowRender: (value, dataRow) => {
                const check = dataRow['imageMatchKpi']

                let backgroundColor = 'divider'
                if (check !== null)
                    backgroundColor = check ? 'success.lighter'  : 'error.lighter'

                return <Box sx={{ textAlign: 'center', fontSize: 14 }}>
                    <ArrowBackground value={value} backgroundColor={backgroundColor}>
                        {value === null && '--'}
                        {value !== null && formatNumber(value, {decimals: 2})}
                    </ArrowBackground>
                </Box>
            }
        }
    },
        {
            name: 'imageMatch', label: 'Image Gallery',
            options: {
                display: 'excluded',
                customBodyRowRender: (_, dataRow) => {
                    const check = dataRow['imageMatchKpi']
                    if (check === null)
                        return 'N/A'
                    return check ? 'Yes' : 'No'
                }
            }
        }]
}